export const medicationUnits = {
  C100052: 'Needle Free Injection',
  C101680: 'French',
  C111984: 'Pump',
  C120216: 'Pen Needle',
  C120263: 'Lancet',
  C16830: 'Device',
  C28251: 'Millimeter',
  C28252: 'Kilogram',
  C28253: 'Milligram',
  C28254: 'Milliliter',
  C38046: 'Unspecified',
  C48155: 'Gram',
  C48473: 'Ampule',
  C48474: 'Bag',
  C48475: 'Bar',
  C48476: 'Bolus',
  C48477: 'Bottle',
  C48478: 'Box',
  C48479: 'Can',
  C48480: 'Capsule',
  C48481: 'Cartridge',
  C48484: 'Container',
  C48489: 'Cylinder',
  C48490: 'Disk',
  C48491: 'Metric Drop',
  C48494: 'Fluid Ounce',
  C48499: 'Implant',
  C48501: 'Inhalation',
  C48504: 'Kit',
  C48505: 'Liter',
  C48506: 'Lozenge',
  C48512: 'Milliequivalent',
  C48519: 'Ounce',
  C48520: 'Package',
  C48521: 'Packet',
  C48524: 'Patch',
  C48529: 'Pint',
  C48530: 'Pouch',
  C48531: 'Pound',
  C48534: 'Quart',
  C48536: 'Scoopful',
  C48537: 'Spray',
  C48538: 'Strip',
  C48539: 'Suppository',
  C48540: 'Syringe',
  C48541: 'Tablespoon',
  C48542: 'Tablet',
  C48543: 'Tampon',
  C48544: 'Teaspoon',
  C48548: 'Troche',
  C48549: 'Tube',
  C48551: 'Vial',
  C48552: 'Wafer',
  C48580: 'Gallon',
  C53495: 'Bead',
  C53498: 'Block',
  C53499: 'Film',
  C53502: 'Sponge',
  C53503: 'Stick',
  C53504: 'Swab',
  C54564: 'Blister',
  C54702: 'Carton',
  C54704: 'Tray',
  C62275: 'Inhaler',
  C62276: 'Insert',
  C62412: 'Applicator',
  C62413: 'Canister',
  C62414: 'Case',
  C62417: 'Dose Pack',
  C62418: 'Inhaler Refill',
  C62421: 'Tabminder',
  C62609: 'Ring',
  C64696: 'Caplet',
  C64933: 'Each',
  C65032: 'Pad',
  C65060: 'Puff',
  C67283: 'Intravenous Bag',
  C69086: 'Ocular System',
  C69093: 'Cassette',
  C71204: 'Nebule',
  C71324: 'Sachet',
  C78783: 'Applicatorful',
  C82484: 'Paper',
  C96265: 'Dual Pack',
  C97717: 'Pre-filled Pen Syringe',
};

export const medicationUnitsOptions = [
  { value: 'C100052', label: 'Needle Free Injection' },
  { value: 'C101680', label: 'French' },
  { value: 'C111984', label: 'Pump' },
  { value: 'C120216', label: 'Pen Needle' },
  { value: 'C120263', label: 'Lancet' },
  { value: 'C16830', label: 'Device' },
  { value: 'C28251', label: 'Millimeter' },
  { value: 'C28252', label: 'Kilogram' },
  { value: 'C28253', label: 'Milligram' },
  { value: 'C28254', label: 'Milliliter' },
  { value: 'C38046', label: 'Unspecified' },
  { value: 'C48155', label: 'Gram' },
  { value: 'C48473', label: 'Ampule' },
  { value: 'C48474', label: 'Bag' },
  { value: 'C48475', label: 'Bar' },
  { value: 'C48476', label: 'Bolus' },
  { value: 'C48477', label: 'Bottle' },
  { value: 'C48478', label: 'Box' },
  { value: 'C48479', label: 'Can' },
  { value: 'C48480', label: 'Capsule' },
  { value: 'C48481', label: 'Cartridge' },
  { value: 'C48484', label: 'Container' },
  { value: 'C48489', label: 'Cylinder' },
  { value: 'C48490', label: 'Disk' },
  { value: 'C48491', label: 'Metric Drop' },
  { value: 'C48494', label: 'Fluid Ounce' },
  { value: 'C48499', label: 'Implant' },
  { value: 'C48501', label: 'Inhalation' },
  { value: 'C48504', label: 'Kit' },
  { value: 'C48505', label: 'Liter' },
  { value: 'C48506', label: 'Lozenge' },
  { value: 'C48512', label: 'Milliequivalent' },
  { value: 'C48519', label: 'Ounce' },
  { value: 'C48520', label: 'Package' },
  { value: 'C48521', label: 'Packet' },
  { value: 'C48524', label: 'Patch' },
  { value: 'C48529', label: 'Pint' },
  { value: 'C48530', label: 'Pouch' },
  { value: 'C48531', label: 'Pound' },
  { value: 'C48534', label: 'Quart' },
  { value: 'C48536', label: 'Scoopful' },
  { value: 'C48537', label: 'Spray' },
  { value: 'C48538', label: 'Strip' },
  { value: 'C48539', label: 'Suppository' },
  { value: 'C48540', label: 'Syringe' },
  { value: 'C48541', label: 'Tablespoon' },
  { value: 'C48542', label: 'Tablet' },
  { value: 'C48543', label: 'Tampon' },
  { value: 'C48544', label: 'Teaspoon' },
  { value: 'C48548', label: 'Troche' },
  { value: 'C48549', label: 'Tube' },
  { value: 'C48551', label: 'Vial' },
  { value: 'C48552', label: 'Wafer' },
  { value: 'C48580', label: 'Gallon' },
  { value: 'C53495', label: 'Bead' },
  { value: 'C53498', label: 'Block' },
  { value: 'C53499', label: 'Film' },
  { value: 'C53502', label: 'Sponge' },
  { value: 'C53503', label: 'Stick' },
  { value: 'C53504', label: 'Swab' },
  { value: 'C54564', label: 'Blister' },
  { value: 'C54702', label: 'Carton' },
  { value: 'C54704', label: 'Tray' },
  { value: 'C62275', label: 'Inhaler' },
  { value: 'C62276', label: 'Insert' },
  { value: 'C62412', label: 'Applicator' },
  { value: 'C62413', label: 'Canister' },
  { value: 'C62414', label: 'Case' },
  { value: 'C62417', label: 'Dose Pack' },
  { value: 'C62418', label: 'Inhaler Refill' },
  { value: 'C62421', label: 'Tabminder' },
  { value: 'C62609', label: 'Ring' },
  { value: 'C64696', label: 'Caplet' },
  { value: 'C64933', label: 'Each' },
  { value: 'C65032', label: 'Pad' },
  { value: 'C65060', label: 'Puff' },
  { value: 'C67283', label: 'Intravenous Bag' },
  { value: 'C69086', label: 'Ocular System' },
  { value: 'C69093', label: 'Cassette' },
  { value: 'C69124', label: 'Gum' },
  { value: 'C71204', label: 'Nebule' },
  { value: 'C71324', label: 'Sachet' },
  { value: 'C78783', label: 'Applicatorful' },
  { value: 'C82484', label: 'Paper' },
  { value: 'C96265', label: 'Dual Pack' },
  { value: 'C97717', label: 'Pre-filled Pen Syringe' },
];

export default medicationUnitsOptions;
